@charset "UTF-8";

/* src/app/webhook-creator/webhook-creator/webhook-log/webhook-log-child/webhook-log-output/webhook-log-output.component.scss */
.text-block {
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}
.cell-with-copy {
  display: flex;
  align-items: center;
  position: relative;
  width: 300px;
  justify-content: space-between;
}
.cell-text {
  display: block;
  width: 150px;
}
.copy-btn {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  padding: 0;
}
.cell-with-copy:hover .copy-btn {
  opacity: 1;
}
.log-output-toolbar {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  position: relative;
  margin-bottom: 10px;
}
/*# sourceMappingURL=webhook-log-output.component.css.map */
